'use strict';

import Shuffle from 'shufflejs';

const plpFilter = (function() {
  const grid = document.querySelector('.js-shuffle-filter');
  const applyFilterButton = document.querySelector('.js-apply-filter');
  const clearFilterButton = document.querySelector('.js-clear-filter');
  const materials = [...document.querySelectorAll('.js-materials input')];
  const patterns = [...document.querySelectorAll('.js-patterns input')];
  const fullcircles = [...document.querySelectorAll('.js-fullcircles input')];
  const pricegroups = [...document.querySelectorAll('.js-pricegroups input')];
  const filterFilters = document.querySelector('.js-filter-filters');
  let shuffleInstance = {};
  let filters = {
    materials: [],
    patterns: [],
    fullcircles: [],
    pricegroups: [],
  };
  function handleFilterChanges() {
    //get the active filters
    filters.materials = getCurrentFilters(materials);
    filters.patterns = getCurrentFilters(patterns);
    filters.fullcircles = getCurrentFilters(fullcircles);
    filters.pricegroups = getCurrentFilters(pricegroups);
    shuffleInstance.filter(itemPassesFilters.bind(this));
    //output filter names to div
    filterFilters.innerHTML = getFilterFilters();
  }
  function getCurrentFilters(inputs) {
    return inputs
      .filter(function(input) {
        return input.checked;
      })
      .map(function(input) {
        return input.value;
      });
  }
  function getFilterFilters() {
    let materials = filters.materials;
    let patterns = filters.patterns;
    let fullcircles = filters.fullcircles;
    let pricegroups = filters.pricegroups;
    let filterText = '';
    // If there are active material filters add to text.
    if (materials.length > 0) {
      filterText += ' / ' + materials[0].replace(/_/g, ' ');
    }
    // If there are active material filters add to text.
    if (patterns.length > 0) {
      filterText += ' / ' + patterns[0].replace(/_/g, ' ');
    }
    // If there are active material filters add to text.
    if (fullcircles.length > 0) {
      filterText += ' / ' + fullcircles[0].replace(/_/g, ' ');
    }
    // If there are active material filters add to text.
    if (pricegroups.length > 0) {
      filterText += ' / ' + pricegroups[0].replace(/_/g, ' ');
    }
    return filterText;
  }
  function itemPassesFilters(element) {
    let materials = filters.materials;
    let patterns = filters.patterns;
    let fullcircles = filters.fullcircles;
    let pricegroups = filters.pricegroups;
    let material = element.getAttribute('data-material') || [];
    let pattern = element.getAttribute('data-pattern') || 'N/A';
    let fullcircle = element.getAttribute('data-fullcircle') || 'N/A';
    let pricegroup = element.getAttribute('data-pricegroup') || 'N/A';

    // If there are active material filters and this material is not in that array.
    if (
      materials.length > 0 &&
      !materials.some(v => material.indexOf(v) >= 0)
    ) {
      return false;
    }

    // If there are active pattern filters and this pattern is not in that array.
    if (patterns.length > 0 && patterns.indexOf(pattern) < 0) {
      return false;
    }

    // If there are active fullcircle filters and this fullcircle is not in that array.
    if (fullcircles.length > 0 && fullcircles.indexOf(fullcircle) < 0) {
      return false;
    }

    // If there are active pricegroup filters and this pricegroup is not in that array.
    if (pricegroups.length > 0 && pricegroups.indexOf(pricegroup) < 0) {
      return false;
    }

    return true;
  }
  function resetFilteredSwatchList() {
    //clear out filters
    filters.materials = [];
    filters.patterns = [];
    filters.fullcircles = [];
    filters.pricegroups = [];
    //clear out filter names
    filterFilters.innerHTML = '';
    //show all items
    shuffleInstance.filter(Shuffle.ALL_ITEMS);
  }
  function init() {
    shuffleInstance = new Shuffle(grid, {
      itemSelector: '.js-item',
      sizer: '.js-shuffle-sizer',
    });
    applyFilterButton?.addEventListener('click', handleFilterChanges);
    clearFilterButton?.addEventListener('click', resetFilteredSwatchList);
  }
  window.addEventListener('DOMContentLoaded', () => {
    if (grid) init();
  });
})();

export default plpFilter;
